export const AccordionPlaceholder = ({ children }) => {
  return <span className="d-flex justify-content-center w-100 font-weight-600 font-size-18 py-24">{children}</span>;
};
